const footerContentArabic = {
  Headings: [
    {
      text: "اكتشف بيتسكلان",
    },
    {
      text: "موارد",
    },
    {
      text: "تواصل معنا",
    },
    {
      text: "حياة مهنية",
    },
    {
      text: "موثوق به من",
    },
    {
      text: "تواصل اجتماعي",
    },
  ],
  services: [
    {
      label: "تطوير الذكاء الاصطناعي",
      path: "/artificial-intelligence-development-services",
    },
    { label: "تطوير مخصص", path: "/custom-software-development-services" },
    { label: "تحليلات البيانات", path: "/data-analytics-services" },
    { label: "تطوير بلوكتشين", path: "/blockchain-development-services" },
    // { label: "الأمن السيبراني", path: "/cyber-security-services" },
    { label: "تطوير تطبيقات الويب", path: "/web-app-development-services" },
    { label: "تطوير تطبيقات الجوال", path: "/mobile-app-development-services" },
    { label: "خدمات ديف أوبس", path: "/dev-ops-services" },
    { label: "خدمات ضمان الجودة", path: "/quality-assurance-services" },
  ],
  company: [
    { label: "الحياة في Bitsclan", path: "/life-at-bitsclan" },
    { label: "نماذج المشاركة", path: "/engagment-model" },
    // { label: "المحفظة", path: "/portfolio" },
    { label: "المدونات", path: "/blogs" },
    // { label: "سياسة الخصوصية", path: "/privacy-policy" },
    // { label: "الشروط والأحكام", path: "/terms-and-conditions" },
    // { label: "اتصل بنا", path: "/contact-us", highlight: true },
  ],
  career: [{ label: "انضم إلى فريق", path: "https://www.theremotepad.com/" }],
  trustedBy: [
    {
      name: "Clutch",
      img: "/images/clutch-footer.svg",
      link: "https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights",
    },
    {
      name: "Payoneer",
      img: "/images/clutch-icons/payoneer-white.png",
      link: "https://www.youtube.com/watch?v=LDmv2CrkM1c&ab_channel=BitsclanITSolutions",
    },
  ],
  socialLinks: [
    {
      platform: "Facebook",
      icon: "fa-brands fa-square-facebook",
      link: "https://www.facebook.com/bitsclan",
    },
    {
      platform: "LinkedIn",
      icon: "fa-brands fa-linkedin",
      link: "https://www.linkedin.com/company/bitsclanitsolutions",
    },
    {
      platform: "Instagram",
      icon: "fa-brands fa-square-instagram",
      link: "https://www.instagram.com/bitsclansolutions/",
    },
  ],
  copyright: "© 2025 جميع الحقوق محفوظة.",
  copyrightLinks: [
    {
      label: "سياسة الخصوصية",
      path: "/privacy-policy",
    },
    {
      label: "الشروط والأحكام",
      path: "/terms-and-conditions",
    },
  ],
  modal: {
    id: "comingsoon-model",
    title: "قريبا,",
    message: "نحن نعمل على ذلك.",
    image: "/images/logo.png",
    imageAlt: "Logo",
  },
  floatingBarData: {
    title: "مرحباً، أنا بروس من Bitsclan.",
    description: "لنجدول مكالمة سريعة لاستكشاف حلول أكثر ذكاءً لفريقك.",
    buttonText: "حدد موعد مكالمة"
  },
  locations: [
    {
      title: "المكتب الرئيسي",
      location: "نيويورك",
      address: "2 بارك أفينيو الطابق 20، نيويورك، NY 10016",
      icon: "new-york.svg",
    },
    {
      title: "مكتب أوروبا",
      location: "السويد",
      address: "بيرغسغاردسجيردت 71، LGH 1101، 424 32 أنجيريد",
      icon: "Sweden.svg",
    },
    {
      title: "مكتب الخليج",
      location: "المملكة العربية السعودية",
      address:
        "المبنى 26/27، الطريق 120 A، صناعات الدعم، مدينة الجبيل الصناعية، المملكة العربية السعودية",
      icon: "Qatar.svg",
    },
    {
      title: "مكتب أستراليا",
      location: "أستراليا",
      address: "ص.ب 1244، فيتزروي نورث، فيكتوريا، 3068",
      icon: "Australia.svg",
    },
  ],
  buttons: {
    contactUs: "اتصل بنا",
    scheduleACall: "حدد موعدًا للاتصال",
  },
  footerCtaContent: {
    heading: "هل تريد تسريع تطوير البرمجيات في شركتك؟",
    subHeading: "انظر كيف يمكننا مساعدتك.",
    buttonText: "جدولة مكالمة"
  }
};

export default footerContentArabic;
